import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { switchMap, catchError, delay } from 'rxjs/operators';

import { environment } from '@environments/environment';

import { JwtService } from './jwt.service';
@Injectable({
  providedIn: 'root'
})
export class JwtInterseptorService {
  constructor(private jwtapi: JwtService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let isExpired = true;

    if (req.url.includes('/oauth/authorize') || req.url?.split(environment.S3_url)?.length === 2 || req.url?.split('payment_methods')[0] === "https://api.stripe.com/v1/" || req.url?.split('customers')[0] === "https://api.stripe.com/v1/" || req.url?.split('setup_intents')[0] === "https://api.stripe.com/v1/" || req.url === "https://api.ipify.org?format=json" || req.url.includes('cron/ui-analytics')) {
      if (req.url?.split(environment.S3_url)?.length === 2) {
        // to prevent caching
        const clone = req.clone({ setHeaders: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' } });
        return next.handle(clone);
      } else {
        return next.handle(req);
      }
    } else {
      const token = this.jwtapi.generateJWTToken('basic');
      return this.jwtapi.addKeyToCache(token.uuidVal).pipe(delay(600)).pipe(switchMap((response) => {
        if (!!token?.accessToken) {
          let clone = req.clone({ setHeaders: { 'Authorization': token.accessToken } });
          return next.handle(clone);
        }
      }), catchError((err) => {
        return throwError(err);
      }));
    }
  }
}
